import React from 'react';
import { GuestSiteTypographyOverride } from '@apps/guest/components/GuestSiteTypographyOverride/GuestSiteTypographyOverride';
import { useTranslation } from '@shared/core';
import { getTravelDistance } from '@shared/utils/distanceInMiles';
import { Flex, TextV2 } from '@withjoy/joykit';
import { body1ToParagraphOverride } from '@apps/guest/components/GuestSiteTypographyOverride/GuestSiteTypographyOverride.constants';
import { WalkIcon } from '@assets/icons';
import { pxToRem } from '@withjoy/joykit/theme';
import { Car } from '@withjoy/joykit/icons';

export const TravelDistance = ({ milesToVenue }: { milesToVenue: string }) => {
  const { t } = useTranslation('guestSiteCustom');
  const accTrans = t('accommodations');
  const travelDistance = getTravelDistance(parseFloat(milesToVenue));
  const travelDistanceLabel = travelDistance.isWalkableDistance ? accTrans.minWalk({ minWalk: travelDistance.minutes }) : accTrans.minDrive({ minDrive: travelDistance.minutes });
  return (
    <Flex width="fit-content" alignItems="center" marginLeft={{ _: 2, sm2: 0 }}>
      <GuestSiteTypographyOverride override={body1ToParagraphOverride} defaultFontFamily="Inter UI">
        {travelDistance?.isWalkableDistance ? <WalkIcon /> : <Car size={16} />}
        <TextV2 typographyVariant="body1" lineHeight={1} marginLeft={2} fontSize={14} maxWidth={{ _: pxToRem(180), sm: pxToRem(260) }} truncate>
          {travelDistanceLabel}
        </TextV2>
      </GuestSiteTypographyOverride>
    </Flex>
  );
};
